import React, { useRef, useEffect, useState } from "react";
import styled from "styled-components";
import useClickOutside from "../library/use-click-outside";
import { GrClose } from "react-icons/gr";
import { StaticImage } from "gatsby-plugin-image";
import { contacts } from "../library/contact-info";
import MobileSideNav from "./mobile-side-nav";
import { device } from "../styles/global";
import { FaFacebookF } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa";

const StyledSideNav = styled.div`
  width: 100vw;

  #overlay,
  nav {
    position: absolute;
    top: 0;
    bottom: 0;
    right: ${(props) => (props.isSideNav ? "0" : "-100vw")};
  }

  #overlay {
    background-color: var(--transparent-white);
    z-index: 100;
    transition: all 0.6s ease-out;
    width: ${(props) => (props.isSideNav ? "100vw" : "0px")};
    cursor: pointer;
  }

  nav {
    z-index: 101;
    width: ${(props) => (props.isSideNav ? "30rem" : "0px")};
    background-color: var(--white);
    cursor: default;
    overflow-y: auto;
  }

  .nav-wrapper {
    padding: ${(props) => props.isSideNav && "3rem 2rem"};
    display: flex;
    flex-direction: column;
    gap: 3rem;
  }

  nav,
  .nav-wrapper {
    transition: all 0.8s ease-in-out;
  }

  button.close {
    align-self: flex-end;

    svg {
      width: 2rem;
      height: 2rem;
      transition: transform 0.2s ease-in-out;
    }

    &:hover svg {
      transform: scale(1.2);
    }
  }

  .logo {
    width: 6.28rem;
  }

  ul.contacts {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    list-style: none;

    li {
      display: flex;
      gap: 1.15rem;
      align-items: center;
    }

    svg {
      color: var(--primary);
      width: 1.5rem;
      height: 1.5rem;
    }
  }

  .socials {
    display: flex;
    gap: 1rem;

    a {
      background-color: var(--primary);
      color: var(--white);
      width: 3rem;
      height: 3rem;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 5px;
      transition: all 0.2s ease-in-out;

      &:hover {
        transform: scale(1.08);
      }
    }

    a.facebook svg {
      height: 1.4rem;
      height: 1.4rem;
    }

    a.linkedin svg {
      height: 1.6rem;
      width: 1.6rem;
    }
  }

  @media ${device.tablet} {
    nav {
      inset: ${(props) => props.isSideNav && "0"};
      width: ${(props) => (props.isSideNav ? "100vw" : "0px")};
    }
  }
`;

const SideNav = ({
  setIsSideNav,
  isSideNav,
  setIsDropdownNav,
  isDropdownNav,
}) => {
  const [isSecondaryLinks, setIsSecondaryLinks] = useState(false);
  const wrapperRef = useRef(null);
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1030
  );

  useClickOutside(wrapperRef, () => setIsSideNav(false));

  // Add a resize event listener to update the window width
  useEffect(() => {
    if (typeof window !== "undefined") {
      const handleResize = () => {
        setWindowWidth(window.innerWidth);
      };

      window.addEventListener("resize", handleResize);

      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }
  }, []);

  useEffect(() => {
    if (!isSideNav) {
      setIsDropdownNav({});
      setIsSecondaryLinks(false);
    }
  }, [isSideNav, setIsDropdownNav, setIsSecondaryLinks]);

  useEffect(() => {
    const container = document.getElementById("scroll-container");
    if (container) {
      if (isSideNav) {
        container.classList.add("no-scroll");
      } else {
        container.classList.remove("no-scroll");
      }
    }
  }, [isSideNav]);

  return (
    <StyledSideNav isSideNav={isSideNav}>
      <div id="overlay" />
      <nav ref={wrapperRef}>
        <div className="nav-wrapper">
          <button onClick={() => setIsSideNav(false)} className="close">
            <GrClose />
          </button>
          {windowWidth > 1024 ? (
            <>
              <StaticImage
                src="../images/logo.png"
                alt="QTA Tax"
                className="logo"
                placeholder="none"
              />
              <p className="body-rg">
                WE SERVICE: Chicago, Elmhurst, Oak Brook, Lombard, Wheaton,
                Downers Grove, Naperville, Bolingbrook, Romeoville, Lockport,
                Orland Park, Elk Grove Village, Schaumburg, Evanston, Carol
                Stream, Elgin, and Northbrook.
              </p>
              <ul className="contacts">
                {contacts.map((contact) => (
                  <li key={contact.title}>
                    <span className="icon">{contact.icon}</span>
                    {contact.text}
                  </li>
                ))}
              </ul>
              <div className="socials">
                <a
                  href="https://www.facebook.com/QTATaxLtd/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="facebook"
                >
                  <FaFacebookF />
                </a>
                <a
                  href="https://www.linkedin.com/in/renata-bliumaite-e-a-b67aa523a/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="linkedin"
                >
                  <FaLinkedinIn />
                </a>
              </div>
            </>
          ) : (
            <MobileSideNav
              setIsDropdownNav={setIsDropdownNav}
              isDropdownNav={isDropdownNav}
              isSecondaryLinks={isSecondaryLinks}
              setIsSecondaryLinks={setIsSecondaryLinks}
            />
          )}
        </div>
      </nav>
    </StyledSideNav>
  );
};

export default SideNav;
